




















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import BatteryLevel from '@/components/shared/BatteryLevel.vue'

import { parserTimeByFormat, parserTimeToUnixAgo, convertSecondsToTime } from '@/_utils/datetime'
import { BEACON_ALERT_CODE, LOCATION_ALERT_CODE } from '@/_consts/BeaconAlertCode'
@Component({
  components: { BatteryLevel },
})
export default class GeofenceNotificationDetail extends Vue {
  @Prop() row!: any

  parseTime: (date: string | Date) => string = parserTimeToUnixAgo
  parseTimeByFormat: (date: any) => string = parserTimeByFormat
  convertSecondsToTime: (date: any) => string = convertSecondsToTime

  beaconAlertParser = BEACON_ALERT_CODE
  locationAlertParser = LOCATION_ALERT_CODE
}
